import { PlusOutlined } from "@ant-design/icons";
import { Card, Flex, message, Upload } from "antd";
import { useCallback, useEffect, useState } from "react";
import { apiRequests } from "src/shared/api/api";

const ImageList = ({ token, entity, entity_id }) => {
  const [pictures, setPictures] = useState([]);

  const loadExistingPictures = useCallback(async () => {
    try {
      const response = await apiRequests.pictures.getItemsOrder(
        entity,
        entity_id,
        token
      );

      if (response.data?.result) {
        const existingPictures = response.data.result.map((item) => ({
          id: item.id,
          name: item.url,
          status: "done",
          url: `https://${process.env.REACT_APP_APP_URL}/api/v1/${item.url}/`,
        }));

        setPictures(existingPictures);
      }
    } catch (error) {
      console.error("Ошибка загрузки существующих изображений:", error);
    }
  }, [entity, entity_id, token]);

  useEffect(() => {
    if (entity && entity_id) {
      loadExistingPictures();
    }
  }, [entity, entity_id, loadExistingPictures]);

  const onDelete = useCallback(
    async (picture) => {

      if (picture.status === "uploading") {
        setPictures((old) => old.filter((e) => e.uid !== picture.uid));
        return true;
      }

      try {
        if (picture.id) {
          await apiRequests.pictures.deleteOrder(picture.id, token);
        }
        message.success("Изображение удалено");
        return true; 
      } catch (error) {
        message.error("Ошибка удаления");
        return false; 
      }
    },
    [token]
  );

  const handleChange = useCallback(({ file, fileList: newFileList }) => {

    setPictures(newFileList);

    if (file.status === "done") {
      if (file.response?.result) {
        const newPic = file.response.result;
        const updatedList = newFileList.map((item) =>
          item.uid === file.uid
            ? {
                ...item,
                id: newPic.id,
                url: `https://${process.env.REACT_APP_APP_URL}/api/v1/${newPic.url}/`,
                name: newPic.url,
                status: "done",
              }
            : item
        );
        setPictures(updatedList);
      }
      message.success("Изображение успешно загружено");
    }

    // Обработка ошибки
    if (file.status === "error") {
      message.error("Ошибка при загрузке изображения");
    }
  }, []);

  return (
    <Card title={"Фотографии"} style={{ marginTop: "20px" }}>
      <Upload
        action={`https://${process.env.REACT_APP_APP_URL}/api/v1/pictures/?token=${token}&entity=${entity}&entity_id=${entity_id}`}
        fileList={pictures}
        listType="picture-card"
        onChange={handleChange}
        onRemove={onDelete}
      >
        <Flex
          vertical
          align={"center"}
          justify={"center"}
          style={{ width: "100%", height: "100%" }}
        >
          <PlusOutlined />
          <span style={{ textAlign: "center", marginTop: "6px" }}>
            Добавить фотографию
          </span>
        </Flex>
      </Upload>
    </Card>
  );
};

export default ImageList;
